module.exports = __webpack_public_path__ + "static/media/header.cb967cfa.png";